import { twMerge } from 'tailwind-merge';
import { AppStoreButtons } from '../../../components/Clickables/Buttons/AppStoreButtons/AppStoreButtons';
import { Container } from '../../../components/Container/Container';
import { Heading } from '../../../components/Heading/Heading';
import { QRCode } from '../../../components/QRCode/QRCode';
import { Text } from '../../../components/Text/Text';

interface IProps {
  headingText: string;
  bodyText: string;
  containerClassName?: string;
  headingClassName?: string;
  bodyClassName?: string;
}

export const HeaderSection = ({
  headingText,
  bodyText,
  containerClassName,
  headingClassName,
  bodyClassName,
}: IProps) => {
  return (
    <Container className={twMerge('mt-sm flex flex-col items-center', containerClassName)}>
      <Heading as="h1" variant="xl" className={twMerge('m-0 text-center', headingClassName)}>
        {headingText}
      </Heading>
      <Text
        variant="lg"
        className={twMerge('md:w-col-9 sm:w-col-11 mt-2 text-center sm:mt-4', bodyClassName)}
      >
        {bodyText}
      </Text>
      <div className="flex flex-row justify-center gap-4 sm:flex-wrap">
        <QRCode
          className="hidden sm:flex sm:justify-center"
          source="FeatureHeaderSection"
          showOnMobileDevice
        />
        <AppStoreButtons orientation="vertical" source="FeatureHeaderSection" />
      </div>
    </Container>
  );
};
